import { getClientType } from "@/react/utils";
import { getThemeColors, getThemeMUIPalette } from "./colors";
import { createTheme } from "@mui/material";
const createThemeFromPalette = (palette) => createTheme({
    palette: palette,
    clientType: getClientType(),
    typography: {
        body2: {
            fontSize: "0.937rem",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "none",
                    },
                },
                contained: {
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "none",
                    },
                },
            },
        },
    },
});
const muiTheme = createThemeFromPalette(getThemeMUIPalette());
const styledTheme = {
    MUITheme: muiTheme,
    theme: {
        mode: "light",
        margin: {
            default: "15px",
            large: "32px",
        },
        colors: getThemeColors(),
        clientType: getClientType(),
        MUITheme: muiTheme,
    },
};
export { styledTheme, createThemeFromPalette };
